<template>
  <q-drawer
    v-model="showDrawer"
    show-if-above
    :mini="!isMobile"
    :overlay="isMobile"
    :persistent="isMobile"
    side="left"
    elevated
    :dark="$q.dark.isActive"
    :class="$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-3'"
    class="column no-wrap"
  >
    <div class="logo-container">
      <img
        v-if="logoUrl"
        :src="logoUrl"
        :style="{
          width: isMobile ? '80px' : '40px',
          height: 'auto',
          marginTop: '12px',
          marginBottom: '10px',
          maxHeight: '40px',
          objectFit: 'contain',
          borderRadius: '4px'
        }"
      />
      <q-img
        v-else
        src="@/assets/logo_Digital_connecting.png"
        :style="{
          width: isMobile ? '80px' : '40px',
          marginTop: '12px',
          marginBottom: '10px',
        }"
      />
    </div>
    <q-separator />
    <q-scroll-area class="fit">
      <q-list>
        <!-- Standard Menu Items -->
        <q-item
          v-for="item in filteredItems"
          :key="item.name"
          :to="item.route"
          :active="route.fullPath == item.route"
          active-class="my-active-class"
          @click="itemClick"
          :disable="item.notAccess"
          clickable
          v-ripple
        >
          <q-item-section avatar>
            <q-icon :name="item.icon">
              <!-- Badge removido conforme pedido do usuário -->
              <q-tooltip
                v-if="!isMobile"
                transition-show="flip-right"
                transition-hide="flip-left"
                anchor="center end"
                self="center start"
              >
                {{ item.name }}
              </q-tooltip>
            </q-icon>
          </q-item-section>
          <q-item-section>
            {{ item.name }}
          </q-item-section>
        </q-item>

        <q-separator class="q-my-md" />

        <!-- Notifications Item 
        <q-item clickable v-ripple>
          <q-item-section avatar>
            <q-icon name="notifications">
              <q-badge v-if="listNotification.length > 0" color="red" floating>
                {{ listNotification.length }}
              </q-badge>
              <q-tooltip
              v-if="!isMobile"
              transition-show="flip-right"
              transition-hide="flip-left"
              anchor="center end"
              self="center start"
              >
                Notificações
              </q-tooltip>
            </q-icon>
          </q-item-section>
          <q-item-section>
            Notificações
          </q-item-section>
          <q-menu anchor="top right" self="top left" :offset="[10, 0]">
            <q-list style="min-width: 250px">
               <q-item-label header v-if="listNotification.length === 0">Nenhuma notificação</q-item-label>
               <q-item
                v-for="(notify, n) in listNotification"
                :key="n"
                @click="handleOpenTicket(notify)"
                clickable
                v-close-popup
                >
                <q-item-section avatar>
                    <q-avatar>
                    <img :src="notify?.profilePicUrl" />
                    </q-avatar>
                </q-item-section>
                <q-item-section>
                    <q-item-label>{{ notify?.name }}</q-item-label>
                    <q-item-label caption class="ellipsis" style="max-width: 150px;">{{ notify.lastMessage }}</q-item-label>
                </q-item-section>
                 <q-item-section side top>
                    <q-item-label caption>{{ notify.time }}</q-item-label>
                    <q-badge v-if="notify.unreadMessages > 0" color="teal">{{ notify.unreadMessages }}</q-badge>
                </q-item-section>
               </q-item>
            </q-list>
          </q-menu>
        </q-item>-->

        <!-- Perfil 
        <q-item clickable v-ripple>
          <q-item-section avatar>
            <q-icon name="person">
               <q-tooltip
              v-if="!isMobile"
              transition-show="flip-right"
              transition-hide="flip-left"
              anchor="center end"
              self="center start"
              >
                Perfil
              </q-tooltip>
            </q-icon>
          </q-item-section>
          <q-item-section>
            Perfil
          </q-item-section>
        </q-item>-->

        <!-- Configurações
        <q-item clickable v-ripple>
          <q-item-section avatar>
            <q-icon name="settings">
               <q-tooltip
              v-if="!isMobile"
              transition-show="flip-right"
              transition-hide="flip-left"
              anchor="center end"
              self="center start"
              >
                Configurações
              </q-tooltip>
            </q-icon>
          </q-item-section>
          <q-item-section>
            Configurações
          </q-item-section>
        </q-item> -->

        <!-- Configurações (Sons, Push, Tema) -->
        <q-item clickable v-ripple>
          <q-item-section avatar>
            <q-icon name="settings">
              <q-tooltip v-if="!isMobile"
                >Configurações e Notificações</q-tooltip
              >
            </q-icon>
          </q-item-section>
          <q-item-section v-if="!$q.screen.mini || isMobile">
            Configurações
          </q-item-section>

          <q-menu anchor="top right" self="top left" :offset="[10, 0]">
            <q-list style="min-width: 200px">
              <q-item-label header>Preferências</q-item-label>

              <!-- Configurações da Empresa (Admin Only) -->
              <q-item
                v-if="userStore?.typeUser === 'admin'"
                clickable
                v-ripple
                @click="router.push('/configuracoes')"
                v-close-popup
              >
                <q-item-section avatar>
                  <q-icon name="admin_panel_settings" size="xs" color="teal" />
                </q-item-section>
                <q-item-section class="text-weight-bold">
                  Configurações da Empresa
                </q-item-section>
                <q-item-section side>
                  <q-icon name="chevron_right" size="xs" />
                </q-item-section>
              </q-item>

              <q-separator v-if="userStore?.typeUser === 'admin'" />

              <!-- Tema -->
              <q-item clickable v-ripple @click="alterTheme">
                <q-item-section avatar>
                  <q-icon :name="iconTheme" size="xs" />
                </q-item-section>
                <q-item-section>
                  {{ textTheme }}
                </q-item-section>
                <q-item-section side>
                  <q-toggle
                    :model-value="$q.dark.isActive"
                    @update:model-value="alterTheme"
                    color="teal"
                    size="xs"
                    dense
                  />
                </q-item-section>
              </q-item>

              <!-- Som -->
              <q-item
                clickable
                v-ripple
                @click="settings.sound = !settings.sound"
              >
                <q-item-section avatar>
                  <q-icon
                    :name="settings.sound ? 'volume_up' : 'volume_off'"
                    size="xs"
                  />
                </q-item-section>
                <q-item-section>
                  Sons: {{ settings.sound ? "Sim" : "Não" }}
                </q-item-section>
                <q-item-section side>
                  <q-toggle
                    v-model="settings.sound"
                    color="teal"
                    size="xs"
                    dense
                  />
                </q-item-section>
              </q-item>

              <!-- Push -->
              <q-item
                clickable
                v-ripple
                @click="settings.notifications = !settings.notifications"
              >
                <q-item-section avatar>
                  <q-icon
                    :name="
                      settings.notifications
                        ? 'notifications_active'
                        : 'notifications_off'
                    "
                    size="xs"
                  />
                </q-item-section>
                <q-item-section>
                  Push: {{ settings.notifications ? "Sim" : "Não" }}
                </q-item-section>
                <q-item-section side>
                  <q-toggle
                    v-model="settings.notifications"
                    color="teal"
                    size="xs"
                    dense
                  />
                </q-item-section>
              </q-item>

              <!-- Assinar -->
              <q-item
                clickable
                v-ripple
                @click="settings.isSigned = !settings.isSigned"
              >
                <q-item-section avatar>
                  <q-icon name="history_edu" size="xs" />
                </q-item-section>
                <q-item-section>
                  Assinar: {{ settings.isSigned ? "Sim" : "Não" }}
                </q-item-section>
                <q-item-section side>
                  <q-toggle
                    v-model="settings.isSigned"
                    color="teal"
                    size="xs"
                    dense
                  />
                </q-item-section>
              </q-item>

              <q-separator />
              <q-item-label header class="row items-center justify-between">
                <span>Recentes</span>
                <q-btn
                  v-if="listNotification.length > 0"
                  flat
                  dense
                  round
                  icon="clear_all"
                  size="sm"
                  color="grey"
                  @click.stop="listNotification = []"
                >
                  <q-tooltip>Limpar Tudo</q-tooltip>
                </q-btn>
              </q-item-label>
              <q-item-label
                v-if="listNotification.length === 0"
                class="q-pa-md text-caption text-grey"
              >
                Nenhuma notificação recente
              </q-item-label>

              <q-item
                v-for="(notify, n) in listNotification"
                :key="n"
                @click="handleOpenTicket(notify)"
                clickable
                v-close-popup
              >
                <q-item-section avatar>
                  <q-avatar
                    size="sm"
                    :color="!notify?.profilePicUrl ? 'teal' : ''"
                    :text-color="!notify?.profilePicUrl ? 'white' : ''"
                  >
                    <img
                      v-if="notify?.profilePicUrl"
                      :src="notify.profilePicUrl"
                    />
                    <span v-else>{{ notify?.name?.charAt(0) || "?" }}</span>
                  </q-avatar>
                </q-item-section>
                <q-item-section>
                  <q-item-label class="text-caption">{{
                    notify?.name
                  }}</q-item-label>
                  <q-item-label caption class="ellipsis">{{
                    notify.lastMessage
                  }}</q-item-label>
                </q-item-section>
                <q-item-section side top>
                  <q-item-label caption>{{ notify.time }}</q-item-label>
                  <q-badge v-if="notify.unreadMessages > 0" color="teal">{{
                    notify.unreadMessages
                  }}</q-badge>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-item>

        <q-separator class="q-my-sm" />

        <!-- Instalar App -->
        <q-item clickable v-ripple @click="installApp" v-if="deferredPrompt">
          <q-item-section avatar>
            <q-icon name="download">
              <q-tooltip
                v-if="!isMobile"
                transition-show="flip-right"
                transition-hide="flip-left"
                anchor="center end"
                self="center start"
              >
                Instalar App
              </q-tooltip>
            </q-icon>
          </q-item-section>
          <q-item-section> Instalar App </q-item-section>
        </q-item>

        <!-- Sair -->
        <q-item clickable v-ripple @click="logout" class="text-red">
          <q-item-section avatar>
            <q-icon name="logout">
              <q-tooltip
                v-if="!isMobile"
                transition-show="flip-right"
                transition-hide="flip-left"
                anchor="center end"
                self="center start"
              >
                Sair
              </q-tooltip>
            </q-icon>
          </q-item-section>
          <q-item-section> Sair </q-item-section>
        </q-item>
      </q-list>
    </q-scroll-area>
  </q-drawer>
</template>
<script>
import { ref, computed, watch, onMounted, onBeforeUnmount, inject } from "vue";
import { useQuasar } from "quasar";
import { useRoute, useRouter } from "vue-router";
import socketManager from "@/config/socket";
import { settings } from "@/utils/settings";
import { notificationService } from "@/utils/notification";
import TicketsController from "@/controllers/TicketsController";
import routes from "@/router/routes";

export default {
  name: "SidebarComponent",
  props: { drawer: Boolean },
  setup(props, { emit }) {
    const $q = useQuasar();
    const route = useRoute();
    const router = useRouter();

    // PWA Install Prompt
    const deferredPrompt = inject("deferredPrompt");

    const isMobile = computed(() => $q.screen.lt.md);
    const showDrawer = ref(props.drawer);
    const logoUrl = ref('');

    const paymentsEnabled = ref(localStorage.getItem('payments_enabled') === 'true');

    const updateLogo = () => {
      logoUrl.value = localStorage.getItem('whitelabel_logo') || '';
    };

    const onStorage = (e) => {
      if (e.key === 'payments_enabled') paymentsEnabled.value = e.newValue === 'true';
      if (e.key === 'whitelabel_logo') updateLogo();
    };

    const textTheme = computed(() =>
      $q.dark.isActive ? "Modo claro" : "Modo escuro"
    );
    const iconTheme = computed(() =>
      $q.dark.isActive ? "brightness_high" : "brightness_4"
    );

    const listNotification = ref([]);
    const unreadCounts = ref({ open: 0, waiting: 0, bot: 0 });
    // Somente contabiliza "Meus Chats" (open) e "Em Espera" (waiting). Ignora chatbots (bot).
    const totalUnread = computed(
      () => unreadCounts.value.open + unreadCounts.value.waiting
    );
    const companyId = localStorage.getItem("company");
    const socket = socketManager.GetSocket(companyId);
    const alertSound = new Audio("/notification.mp3");
    const notifiedMessageIds = new Set();

    watch(
      () => props.drawer,
      (newVal) => {
        showDrawer.value = newVal;
      }
    );

    let userStore = null;
    try {
      const userString = localStorage.getItem("user");
      if (userString) {
        userStore = JSON.parse(userString);
      }
    } catch (error) {
      console.error("Erro ao parsear user do localStorage:", error);
      userStore = null;
    }

    const items = ref([]);
    const loadingMenu = ref(true);

    const PAYMENT_ROUTES = ['/planos', '/bancos', '/configuracoes-fiscais', '/contas-a-receber'];

    const filteredItems = computed(() => {
      return items.value.filter((item) => {
        if (item.hideMobile && isMobile.value) return false;
        if (item.notAccess) return false;
        if (PAYMENT_ROUTES.includes(item.route) && !paymentsEnabled.value) return false;
        return true;
      });
    });

    onMounted(async () => {
      try {
        loadingMenu.value = true;
        const menus = await routes.AuthController.getMenus();
        items.value = menus || [];
      } catch (e) {
        console.error("Erro ao buscar menus", e);
      } finally {
        loadingMenu.value = false;
      }
    });

    function itemClick() {
      if (isMobile.value) {
        emit("toggleDrawer");
      }
    }

    async function installApp() {
      if (deferredPrompt.value) {
        deferredPrompt.value.prompt();
        const { outcome } = await deferredPrompt.value.userChoice;
        if (outcome === "accepted") {
          deferredPrompt.value = null;
        }
      }
    }

    // --- Header Functions copied here ---

    function getHour(timestamp) {
      const date = new Date(timestamp);
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    // Atualiza contadores quando a rota muda (ex: ao entrar em um ticket)
    watch(
      () => route.query.id,
      (newId) => {
        if (newId) {
          // Pequeno delay para garantir que o backend já processou a leitura se for automático
          setTimeout(fetchUnreadCounts, 1000);
        }
      }
    );

    function notification(data) {
      console.log("[SidebarComponent] Processando notificação:", data);

      const isFromMe = data.message?.fromMe || data.fromMe || false;
      if (isFromMe) {
        console.log(
          "[SidebarComponent] Ignorando notificação visual/sonora (enviada por mim)."
        );
        fetchUnreadCounts();
        return;
      }

      const ticketId = data.ticket?.id || data.message?.ticketId;
      const content = (
        data.ticket?.lastMessage ||
        data.message?.body ||
        ""
      ).trim();
      const messageId = data?.message?.id;

      if (!ticketId || (!content && !messageId)) {
        console.log(
          "[SidebarComponent] Ignorando notificação (sem ticketId ou conteúdo/id)."
        );
        return;
      }

      // Chave de de-duplicação: prioriza o messageId real para permitir mensagens idênticas em sequência
      const deDupKey = messageId
        ? `msg:${messageId}`
        : `alert:${ticketId}:${content}`;

      if (notifiedMessageIds.has(deDupKey)) {
        console.log(
          "[SidebarComponent] Notificação ignorada (duplicada):",
          deDupKey
        );
        return;
      }

      notifiedMessageIds.add(deDupKey);
      setTimeout(() => notifiedMessageIds.delete(deDupKey), 15000); // 15s

      const isActiveChat = window.activeTicketId == ticketId;
      const isDocumentFocused = document.hasFocus();

      // Sempre adiciona à lista de notificações do menu lateral (Sininho)
      listNotification.value = listNotification.value.filter(
        (item) => item?.id !== ticketId
      );
      listNotification.value.unshift({
        id: ticketId,
        profilePicUrl: data?.contact?.profilePicUrl,
        name: data?.contact?.name,
        lastMessage: content,
        // Só marca como não lida no Sininho se NÃO for o chat ativo
        unreadMessages: isActiveChat ? 0 : data?.ticket?.unreadMessages || 1,
        time: getHour(data?.message?.createdAt || new Date().toISOString()),
      });

      // Update unread counts
      fetchUnreadCounts();

      if (ticketId && data?.message?.fromMe !== true) {
        // Som de alerta (se ativado)
        if (settings.sound) {
          // Só toca o som se:
          // 1. NÃO for o chat ativo
          // 2. OU se for o chat ativo mas a janela NÃO estiver focada (minimizada)
          if (!isActiveChat || !isDocumentFocused) {
            const now = Date.now();
            if (!window.lastSoundTime || now - window.lastSoundTime > 1000) {
              window.lastSoundTime = now;
              console.log("[SidebarComponent] Reproduzindo som de alerta...");
              alertSound.currentTime = 0;
              alertSound.play().catch((error) => {
                console.error(
                  "[SidebarComponent] Erro ao reproduzir o som de alerta:",
                  error
                );
                if (
                  error.name === "NotAllowedError" &&
                  !window.audioErrorShown
                ) {
                  window.audioErrorShown = true;
                  $q.notify({
                    message:
                      "O som de notificação está bloqueado pelo navegador. Clique em qualquer lugar da página para ativar.",
                    color: "orange-9",
                    textColor: "white",
                    position: "top",
                    icon: "volume_off",
                    timeout: 10000,
                  });
                }
              });
            }
          } else {
            console.log(
              "[SidebarComponent] Som suprimido (usuário está no chat ativo e focado)"
            );
          }
        }

        // Notificação do navegador
        if (settings.notifications) {
          const isActiveChat = window.activeTicketId == ticketId;
          const isDocumentFocused = document.hasFocus();

          // DEBUG: console.log("[SidebarComponent] Push check:", { isActiveChat, isDocumentFocused, state: document.visibilityState });

          // Mostra push se:
          // 1. A aba NÃO estiver focada (independente de ser o chat ativo ou não)
          // 2. OU se estiver focada mas NÃO for o chat ativo
          if (!isDocumentFocused || !isActiveChat) {
            console.log(
              "[SidebarComponent] Disparando notificação do navegador para ticket:",
              ticketId
            );
            // Adicionar o número total na notificação (incluindo a nova mensagem)
            const nextCount = totalUnread.value + 1;
            notificationService.showBrowserNotification(
              `(${nextCount}) Nova mensagem de ${
                data?.contact?.name || "Cliente"
              }`,
              data?.lastMessage || "Você recebeu uma nova mensagem.",
              data?.contact?.profilePicUrl || "/img/icons/icon.png",
              () => {
                console.log(
                  "[SidebarComponent] Navegando para o ticket via notificação:",
                  ticketId
                );
                router.push({ path: "/atendimento", query: { id: ticketId } });
              }
            );
          } else {
            console.log(
              "[SidebarComponent] Notificação push suprimida (usuário já está no chat ativo)"
            );
          }
        } else {
          console.log(
            "[SidebarComponent] Notificações push desativadas nas configurações."
          );
        }
      } else {
        console.log(
          "[SidebarComponent] Notificação ignorada (fromMe ou sem ticketId)"
        );
      }
    }

    let debounceTimer = null;
    async function fetchUnreadCounts() {
      if (debounceTimer) return;

      debounceTimer = setTimeout(() => {
        debounceTimer = null;
      }, 3000); // 3 seconds throttle

      try {
        // Zera o timer de debounce para permitir nova chamada após o término se necessário
        // (Mas mantemos um throttle real de 3 segundos para evitar excesso)

        // TicketsController.index returns counts for all statuses
        const response = await TicketsController.index({
          limit: 0,
          status: "open",
        });
        if (response && response.counts) {
          const counts = response.counts;
          unreadCounts.value = {
            open: counts.open || 0,
            waiting: counts.waiting || 0,
            bot: counts.bot || 0,
          };
        }
      } catch (err) {
        console.error("[SidebarComponent] Erro ao buscar unread counts:", err);
      }
    }

    function onNewTicketOrMessage(data) {
      console.log(
        "[SidebarComponent] Novo evento recebido (ticket/message):",
        data
      );

      // Só processa alertas se houver um objeto de mensagem real (evita notificar 'carregamento' de lista antiga)
      if (!data.message && data.action !== "create") {
        console.log(
          "[SidebarComponent] Atualizando apenas contadores (evento sem mensagem)."
        );
        fetchUnreadCounts();
        return;
      }

      // Detectar 'fromMe' de forma mais robusta
      const fromMe =
        data.message?.fromMe || data.ticket?.lastMessageFromMe || false;

      const normalizedData = {
        ticket: data.ticket || {
          id: data.message?.ticketId,
          lastMessage: data.message?.body,
          unreadMessages: 1,
        },
        message: data.message || {
          createdAt: new Date().toISOString(),
          fromMe: fromMe,
          body: data.ticket?.lastMessage,
        },
        contact: data.contact || data.ticket?.contact || {},
        fromMe: fromMe,
      };
      notification(normalizedData);
    }

    function alterTheme() {
      const newStatus = !$q.dark.isActive;
      $q.dark.set(newStatus);
      localStorage.setItem("darkMode", newStatus);
    }

    function logout() {
      localStorage.removeItem("token");
      router.push("/login");
    }

    function handleOpenTicket(notify) {
      router.push({ path: "/atendimento", query: { id: notify.id } });
      // Remove from notification list
      listNotification.value = listNotification.value.filter(
        (item) => item.id !== notify.id
      );
    }

    onMounted(() => {
      updateLogo();
      window.addEventListener('storage', onStorage);

      // We only join notification room if we have a socket.
      // Assuming socketManager works same way.
      if (socket) {
        console.log(
          "[SidebarComponent] Inicializando ouvintes globais de notificação..."
        );
        socket.emit(`joinNotification`);

        // Ouvindo eventos centrais de ticket e mensagem
        socket.on(`company-${companyId}-ticket`, (data) => {
          console.log(
            "[SidebarComponent] Evento de ticket recebido:",
            data.action,
            "Rota atual:",
            route.path
          );
          onNewTicketOrMessage(data);
        });
        socket.on(`company-${companyId}-message`, (data) => {
          console.log(
            "[SidebarComponent] Evento de mensagem recebido:",
            data.action,
            "Rota atual:",
            route.path
          );
          onNewTicketOrMessage(data);
        });

        // Garantir que os contadores iniciem carregados
        fetchUnreadCounts();
      } else {
        console.error("[SidebarComponent] Socket não disponível no mount.");
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('storage', onStorage);
      if (socket) {
        socket.off(`company-${companyId}-ticket`);
        socket.off(`company-${companyId}-message`);
      }
    });

    return {
      route,
      showDrawer,
      isMobile,
      paymentsEnabled,
      items,
      filteredItems,
      itemClick,
      listNotification,
      textTheme,
      iconTheme,
      alterTheme,
      logout,
      handleOpenTicket,
      installApp,
      deferredPrompt,
      settings,
      totalUnread,
      userStore,
      router,
      logoUrl,
    };
  },
};
</script>
<style scoped>
.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bg-premium-dark {
  background-color: #0b0c0d !important;
}
::v-deep .my-active-class {
  color: #009688 !important;
  border-right: 5px solid #009688 !important;
}
::v-deep .q-item {
  cursor: pointer;
  pointer-events: auto;
}
::v-deep .q-item--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
